import React from "react";

const PagePropsContext = React.createContext();

export default PagePropsContext;
